import svg from 'src/images/custom-icons/operations.icon.svg';

const operationsSideBarTokens = {
    iconData: svg,
    iconWidth: 20,
    iconHeight: 20,
    iconTitle: 'Operations'
};

export default operationsSideBarTokens;
